import axios from "axios";

export default axios.create({
  baseURL: "https://savereurope.com/wp-json/api/v2",
  // baseURL: "https://savereurope.360southclients.com/wp-json/api/v2",
});
